import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getLaborScopeRawParts = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.laborTicketParts;
  }
);
